import modules from '@/app/config/modules'
import assign from 'lodash/assign'
import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/app/config/vuex-store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},

  mutations: {
    init(state) {
      const persisted = localStorage.getItem(config.localStorageId)
      if (persisted) {
        assign(state, JSON.parse(persisted))
      }
    },

    // purge (state) {
    //   localStorage.removeItem(config.localStorageId)
    // }
  },

  actions: {},

  modules,
})

store.subscribe((_, state) => {
  localStorage.setItem(config.localStorageId, JSON.stringify(state))
})

export default store
